import { Auth } from "./auth";
import { JiraIssuesEndpoint } from "./endpoints/JiraIssuesEndpoint";
import { JiraConfigsEndpoint } from "./endpoints/JiraConfigsEndpoint";
import { SlackConfigsEndpoint } from "./endpoints/SlackConfigsEndpoint";
import { WorkersEndpoint } from "./endpoints/WorkersEndpoint";
import { ProjectsEndpoint } from "./endpoints/ProjectsEndpoint";
import { CasesEndpoint } from "./endpoints/CasesEndpoint";
import { SuitesEndpoint } from "./endpoints/SuitesEndpoint";
import { SchedulesEndpoint } from "./endpoints/SchedulesEndpoint";
import { CyclesEndpoint } from "./endpoints/CyclesEndpoint";
import { CycleMessagesEndpoint } from "./endpoints/CycleMessagesEndpoint";
import { FilesEndpoint } from "./endpoints/FilesEndpoint";
import { UsersEndpoint } from "./endpoints/UsersEndpoint";
import { ArtifactsEndpoint } from "./endpoints/ArtifactsEndpoint";
import { ClientsEndpoint } from "./endpoints/ClientsEndpoint";
import { RegistrationEndpoint } from "./endpoints/RegistrationEndpoint";
import { PasswordResetEndpoint } from "./endpoints/PasswordResetEndpoint";
import { InvitationsEndpoint } from "./endpoints/InvitationsEndpoint";
import { ProjectFilesEndpoint } from "./endpoints/ProjectFilesEndpoint";
import { EnvironmentsEndpoint } from "./endpoints/EnvironmentsEndpoint";
import { McpEndpoint } from "./endpoints/McpEndpoint";
import { DemoEndpoint } from "./endpoints/DemoEndpoint";

class ApiWrapper {
  private static instance: ApiWrapper;

  public auth: Auth;
  public jiraIssues: JiraIssuesEndpoint;
  public jiraConfigs: JiraConfigsEndpoint;
  public slackConfigs: SlackConfigsEndpoint;
  public workers: WorkersEndpoint;
  public projects: ProjectsEndpoint;
  public cases: CasesEndpoint;
  public suites: SuitesEndpoint;
  public schedules: SchedulesEndpoint;
  public cycles: CyclesEndpoint;
  public cycleMessages: CycleMessagesEndpoint;
  public files: FilesEndpoint;
  public users: UsersEndpoint;
  public artifacts: ArtifactsEndpoint;
  public clients: ClientsEndpoint;
  public registration: RegistrationEndpoint;
  public passwordReset: PasswordResetEndpoint;
  public invitations: InvitationsEndpoint;
  public projectFiles: ProjectFilesEndpoint;
  public environments: EnvironmentsEndpoint;
  public mcp: McpEndpoint;
  public demo: DemoEndpoint;

  public removeAuthToken = Auth.getInstance().removeAuthToken;

  private constructor() {
    this.auth = Auth.getInstance();
    this.jiraIssues = new JiraIssuesEndpoint();
    this.jiraConfigs = new JiraConfigsEndpoint();
    this.slackConfigs = new SlackConfigsEndpoint();
    this.workers = new WorkersEndpoint(this.auth);
    this.projects = new ProjectsEndpoint(this.auth);
    this.cases = new CasesEndpoint(this.auth);
    this.suites = new SuitesEndpoint(this.auth);
    this.schedules = new SchedulesEndpoint(this.auth);
    this.cycles = new CyclesEndpoint(this.auth);
    this.cycleMessages = new CycleMessagesEndpoint(this.auth);
    this.files = new FilesEndpoint(this.auth);
    this.users = new UsersEndpoint(this.auth);
    this.artifacts = new ArtifactsEndpoint(this.auth);
    this.clients = new ClientsEndpoint(this.auth);
    this.registration = new RegistrationEndpoint(this.auth);
    this.passwordReset = new PasswordResetEndpoint(this.auth);
    this.invitations = new InvitationsEndpoint(this.auth);
    this.projectFiles = new ProjectFilesEndpoint(this.auth);
    this.environments = new EnvironmentsEndpoint(this.auth);
    this.mcp = new McpEndpoint(this.auth);
    this.demo = new DemoEndpoint();
  }

  public static getInstance(): ApiWrapper {
    if (!ApiWrapper.instance) ApiWrapper.instance = new ApiWrapper();
    return ApiWrapper.instance;
  }
}

export const api = ApiWrapper.getInstance();
export { JiraIssuesEndpoint } from "./endpoints/JiraIssuesEndpoint";
export { JiraConfigsEndpoint } from "./endpoints/JiraConfigsEndpoint";
export { SlackConfigsEndpoint } from "./endpoints/SlackConfigsEndpoint";

export type { ActionReturnType } from "./types";
export { WorkersEndpoint } from "./endpoints/WorkersEndpoint";
export { ProjectsEndpoint } from "./endpoints/ProjectsEndpoint";
export { CasesEndpoint } from "./endpoints/CasesEndpoint";
export { SuitesEndpoint } from "./endpoints/SuitesEndpoint";
export { SchedulesEndpoint } from "./endpoints/SchedulesEndpoint";
export { CyclesEndpoint } from "./endpoints/CyclesEndpoint";
export { CycleMessagesEndpoint } from "./endpoints/CycleMessagesEndpoint";
export { FilesEndpoint } from "./endpoints/FilesEndpoint";
export { UsersEndpoint } from "./endpoints/UsersEndpoint";
export { ArtifactsEndpoint } from "./endpoints/ArtifactsEndpoint";
export { ClientsEndpoint } from "./endpoints/ClientsEndpoint";
export { RegistrationEndpoint } from "./endpoints/RegistrationEndpoint";
export { PasswordResetEndpoint } from "./endpoints/PasswordResetEndpoint";
export { InvitationsEndpoint } from "./endpoints/InvitationsEndpoint";
export { ProjectFilesEndpoint } from "./endpoints/ProjectFilesEndpoint";
export { EnvironmentsEndpoint } from "./endpoints/EnvironmentsEndpoint";
export { McpEndpoint } from "./endpoints/McpEndpoint";
